import { Grid, Typography } from '@mui/material';
import { usePqrWebResponseMedium } from './hook';
import { PqrWebResponseMediumProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const PqrWebResponseMedium = (props: PqrWebResponseMediumProps) => {
    const { formik, responseMediums } = usePqrWebResponseMedium(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Medio de respuesta
                </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
                <AutocompleteField
                    data={formatParams(responseMediums)}
                    label="Medio de respuesta"
                    name="responseMedium"
                    size="small"
                    required
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.responseMedium}
                    errors={formik.errors.responseMedium}
                    value={formik.values.responseMedium}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('responseMedium', value)
                    }
                />
            </Grid>
            <Grid item xs={12} md={8} mt={1}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    "El trámite de respuesta a su solicitud no tendrá ningún
                    costo"
                </Typography>
            </Grid>
        </Grid>
    );
};
